<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Novo</button>            

            <span class="float-right">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="search()">
                        <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clearFilter()">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn" [class.btn-light]="!filterCollapse.isFilterDirty" [class.btn-danger]="filterCollapse.isFilterDirty"
                        (click)="filterCollapse.toggleCollapse()">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="filterCollapse.collapseIcon" aria-hidden="true"></i>
                    </button>
                </div>                
            </span>            
        </div>
    </div>
    <div class="row container-table" #containerTable>
        <div class="col-12">
            <div class="row container-filter">
                <div class="col-12">
                    <sgt-usuario-filter-collapse
                        [filter]="filter"
                        (filterInitialized)="onFilterInitialized()"
                        #filterCollapse>
                    </sgt-usuario-filter-collapse>
                </div>
            </div>
                
            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-hover datatables table-usuarios" id="tableUsuarios">
                        <thead>
                            <tr>
                                <th class="col-options"></th>
                                <th class="col-usuario">Usuário</th>
                                <th class="col-perfil text-center">Perfil</th>
                                <th class="col-situacao text-center">Situação</th>
                            </tr>
                        </thead>
                    </table>                     
                </div>
            </div>
        </div>
    </div>    
</div>

<!-- Container para criar dinamicamente os avatares dos usuários -->
<ng-template #avatarContainer></ng-template>

<!-- Modal para alterar a senha -->
<sgt-usuario-altera-senha-modal
    idModal="usuarioAlteraSenhaModal"
    #usuarioAlteraSenhaModal>
</sgt-usuario-altera-senha-modal>